import React from 'react'

export default ({ video }) => (
  <div className="event-media media-video">
    <div className="aspect-ratio" dangerouslySetInnerHTML={{ __html: video }} />
  </div>
)
